module.exports = __webpack_public_path__ + "static/img/tiger.952bf3e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ThreeJS/textures/tiger.svg
// module id = zqFf
// module chunks = 0 1